import {Box, IconButton, makeStyles, Typography} from "@material-ui/core";
import {useFieldArray, useFormContext} from "react-hook-form"
import CustomSelect from "../../../components/CustomSelect/CustomSelect";
import CustomTextField from "../../../components/CustomTextField/CustomTextField";
import {useCallback} from "react";
import closeIcon from "../../../assets/img/close.svg";
import {white} from "../../../constants/colors";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
    ffLabel: {
        color: '#71777D',
        fontFamily: "sbcBold",
        fontSize: 12,
        cursor: 'pointer'
    },
    grid: {
        display: 'flex',
        gap: 10,
        position: 'relative'
    },
    removeButton: {
        position: 'absolute',
        right: -10,
        top: -10,
        backgroundColor: white,
        cursor: 'pointer',
        padding: 8,
        boxShadow: "0px 3px 14px rgba(0, 0, 0, 0.15)",
        "&:hover": {
            backgroundColor: white,
        },
    }
}))

const NestedFrequentFlyersForm = ({ nestIndex, airlines, selectedFlight }) => {
    const { ffLabel, grid, removeButton } = useStyles();
    const { control } = useFormContext();

    const { fields, remove, append } = useFieldArray({
        control,
        name: `passengers[${nestIndex}].frequentFlyer`,
        shouldUnregister: false
    });

  const airlineOptions = Object.values(airlines).filter(airline => selectedFlight.available_airlines.includes(airline.id))?.map((airline) => ({
        label: airline.name,
        value: airline.id
    })).sort((a, b) => a.label.localeCompare(b.label))
    const removeField = useCallback((index) => {
        remove(index)
    }, [remove])

    return (
        <Box>
            {fields?.map((field, index) => (
                <Box key={`${field.airline_pk}-${field.frequent_flyer_number}-${index}`} className={grid}>
                    <CustomSelect
                        name={`passengers[${nestIndex}].frequentFlyer[${index}].airline_pk`}
                        options={airlineOptions}
                        label={'Airline'}
                        placeholder={'Choose Airline'}
                        defaultValue={field?.airline_pk}
                        withoutEmpty
                    />
                    <CustomTextField
                        label="Frequent Flyer Number"
                        defaultValue={field?.frequent_flyer_number}
                        name={`passengers[${nestIndex}].frequentFlyer[${index}].frequent_flyer_number`}
                        placeholder={'Input FF Number'}
                    />
                    {index > 0 ? (
                        <IconButton className={removeButton} onClick={() => removeField(index)} size="small">
                            <img src={closeIcon} alt="menuicon" width={10} height={10} />
                        </IconButton>
                    ) : null}
                </Box>
            ))}

            <Typography variant="caption" className={ffLabel} onClick={() => append({
                airline_pk: '',
                frequent_flyer_number: ''
            })}>
                + Add another FF Number
            </Typography>
        </Box>
    )
}

export default NestedFrequentFlyersForm
